
function DatatableAjaxSearch(id, url) {

    var table = $(id).dataTable();

    //Grab the current global table settings for the table
    tableOptions = table.fnSettings();

    //Destroy the current table to rebuild
    table.DataTable().destroy();

    //Settings to make AJAX call
    tableOptions.processing = true;
    tableOptions.serverSide = false;
    tableOptions.ajax = {
        url: url,
        type: 'POST',
        data: function (d) {
            d.search = $(id + '_filter input').val();
        }
    };

    // Creates the search button
    tableOptions.initComplete = function () {
        var input = $('.dataTables_filter input').unbind(),
            self = this.api(),
            $searchButton = $('<button class="btn btn-primary searchButton">')
                .text('Search')
                .click(function () {
                    self.ajax.reload();
                })
        input.on('keypress', function (e) {
            if (e.keyCode === 13) {
                self.ajax.reload();
            }
        });
        $('.dataTables_filter').append($searchButton);
    }

    //Pagination settings
    tableOptions.paging = true;
    tableOptions.pagingType = 'simple';
    tableOptions.lengthMenu = [[10, 25, 50, 100], [10, 25, 50, 100]];

    //Sort by the first column
    tableOptions.aaSorting = [[0, "desc"]];

    //Create the table using the updated settings
    table.DataTable(tableOptions);
}